import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IDocusignApiClient {
  sendCreditAuthRemoteSigningEmail: (
    igsCustomerNumber: string
  ) => ng.IPromise<void>;
  sendElectronicConsentRemoteSigningEmail: (
    igsCustomerNumber: string
  ) => ng.IPromise<void>;
  sendContractRemoteSigningEmail: (
    contractEnvelopeRequest: Models.ContractOptions.ContractEnvelopeRequest.IContractEnvelopeRequest
  ) => ng.IPromise<void>;
  sendPaymentAuthRemoteSigningEmail: (
    igsCustomerNumber: string
  ) => ng.IPromise<void>;
  sendSystemDetailsDisclosureRemoteSigningEmail: (
    igsCustomerNumber: string
  ) => ng.IPromise<void>;

  getCreditAuthEnvelopeUrlForCustomer: (
    igsCustomerNumber: string
  ) => ng.IPromise<string>;
  getElectronicConsentEnvelopeUrlForCustomer: (
    igsCustomerNumber: string
  ) => ng.IPromise<string>;
  getContractEnvelopeUrlForCustomer: (
    contractEnvelopeRequest: Models.ContractOptions.ContractEnvelopeRequest.IContractEnvelopeRequest
  ) => ng.IPromise<string>;
  getPaymentAuthEnvelopeUrlForCustomer: (
    igsCustomerNumber: string
  ) => ng.IPromise<string>;
  getSystemDetailsDisclosureEnvelopeUrlForCustomer: (
    igsCustomerNumber: string
  ) => ng.IPromise<string>;

  updateDocumentSigningStatus(
    updateDocumentSigningStatusRequest: Models.DocumentManagement.UpdateDocumentSignStatusRequest.IUpdateDocumentSigningStatusRequest
  ): ng.IPromise<string>;
  getActiveDocusignEnvelopes: (
    igsCustomerNumber: string
  ) => ng.IPromise<
    Models.DocumentManagement.DocusignEnvelope.IDocusignEnvelope[]
  >;
  // returns number of seconds before agent can resync with docusign (0 if successfully synced during request)
  syncCustomerWithDocusign: (
    igsCustomerNumber: string
  ) => ng.IPromise<
    Models.DocumentManagement.DocusignSyncResult.IDocusignSyncResult
  >;
  voidEnvelope: (remoteEnvelopeId: string, reason: string) => ng.IPromise<void>;

  cancelPendingContract: (
    igsCustomerNumber: string
  ) => ng.IPromise<Models.DocumentManagement.CancelPendingContractResponse.ICancelPendingContractResponse>;

}

export class DocusignApiClient implements IDocusignApiClient {
  public prefix: string;

  public static $inject = [
    "igs.apiClientService"
  ];

  constructor(
    private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    this.prefix = "Docusign";
  }

  public sendCreditAuthRemoteSigningEmail = (
    igsCustomerNumber: string
  ): ng.IPromise<void> => {
    var url = `${this.prefix}/SendCreditAuthRemoteSigningEmail/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public sendElectronicConsentRemoteSigningEmail = (
    igsCustomerNumber: string
  ): ng.IPromise<void> => {
    var url = `${this.prefix}/SendElectronicConsentRemoteSigningEmail/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public sendContractRemoteSigningEmail = (
    contractEnvelopeRequest: Models.ContractOptions.ContractEnvelopeRequest.IContractEnvelopeRequest
  ): ng.IPromise<void> => {
    var url = `${this.prefix}/SendContractRemoteSigningEmail`;
    return this.igsApiClientService.post(url, contractEnvelopeRequest);
  };

  public sendPaymentAuthRemoteSigningEmail = (
    igsCustomerNumber: string
  ): ng.IPromise<void> => {
    var url = `${this.prefix}/SendPaymentAuthRemoteSigningEmail/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public sendSystemDetailsDisclosureRemoteSigningEmail = (
    igsCustomerNumber: string
  ): ng.IPromise<void> => {
    var url = `${this.prefix}/SendSystemDetailsDisclosureRemoteSigningEmail/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public getCreditAuthEnvelopeUrlForCustomer = (
    igsCustomerNumber: string
  ): ng.IPromise<string> => {
    var url = `${this.prefix}/GetCreditAuthEnvelopeUrlForCustomer/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public getElectronicConsentEnvelopeUrlForCustomer = (
    igsCustomerNumber: string
  ): ng.IPromise<string> => {
    var url = `${this.prefix}/GetElectronicConsentEnvelopeUrlForCustomer/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public getContractEnvelopeUrlForCustomer = (
    contractEnvelopeRequest: Models.ContractOptions.ContractEnvelopeRequest.IContractEnvelopeRequest
  ): ng.IPromise<string> => {
    var url = `${this.prefix}/GetContractEnvelopeUrlForCustomer`;
    return this.igsApiClientService.post(url, contractEnvelopeRequest);
  };

  public getPaymentAuthEnvelopeUrlForCustomer = (
    igsCustomerNumber: string
  ): ng.IPromise<string> => {
    var url = `${this.prefix}/GetPaymentAuthEnvelopeUrlForCustomer/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public getSystemDetailsDisclosureEnvelopeUrlForCustomer = (
    igsCustomerNumber: string
  ): ng.IPromise<string> => {
    var url = `${this.prefix}/GetSystemDetailsDisclosureEnvelopeUrlForCustomer/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public updateDocumentSigningStatus = (
    updateDocumentSigningStatusRequest: Models.DocumentManagement.UpdateDocumentSignStatusRequest.IUpdateDocumentSigningStatusRequest
  ): ng.IPromise<string> => {
    var url = `${this.prefix}/UpdateDocumentSigningStatus`;
    return this.igsApiClientService.post(
      url,
      updateDocumentSigningStatusRequest
    );
  };

  public getActiveDocusignEnvelopes = (
    igsCustomerNumber: string
  ): ng.IPromise<
    Models.DocumentManagement.DocusignEnvelope.IDocusignEnvelope[]
  > => {
    var url = `${this.prefix}/GetActiveDocusignEnvelopes/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public syncCustomerWithDocusign = (
    igsCustomerNumber: string
  ): ng.IPromise<
    Models.DocumentManagement.DocusignSyncResult.IDocusignSyncResult
  > => {
    var url = `${this.prefix}/SyncCustomerWithDocusign/${igsCustomerNumber}`;
    return this.igsApiClientService.get(url);
  };

  public voidEnvelope = (
    remoteEnvelopeId: string,
    reason: string
  ): ng.IPromise<void> => {
    var url = `${this.prefix}/VoidEnvelope`;
    var data = new Models.DocumentManagement.DocusignEnvelopeVoidRequest.DocusignEnvelopeVoidRequest(
      remoteEnvelopeId,
      reason
    );
    return this.igsApiClientService.post(url, data);
  };

  public cancelPendingContract = (
    igsCustomerNumber: string
  ): ng.IPromise<Models.DocumentManagement.CancelPendingContractResponse.ICancelPendingContractResponse> => {
    var url = `${this.prefix}/CancelPendingContract/${igsCustomerNumber}`;
    return this.igsApiClientService.post(url);
  };
}
